'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var generatedCraftcms = require('@liquorice/generated-craftcms');
var material = require('@mui/material');
var createFieldControl = require('../lib/form/createFieldControl.js');

const FIELD_SECTION_FRAGMENT = generatedCraftcms.gql(`
  fragment fieldSection on Field_Section {
    __typename
    ...fieldBase
  }
`);
const Field_Section = createFieldControl.createField(FIELD_SECTION_FRAGMENT, (_field, _props)=>{
    return /*#__PURE__*/ jsxRuntime.jsx(material.Divider, {});
});

exports.FIELD_SECTION_FRAGMENT = FIELD_SECTION_FRAGMENT;
exports.Field_Section = Field_Section;
